import React from 'react';
// import sections
import Hero from '../components/sections/Hero';
import FeaturesTiles from '../components/sections/FeaturesTiles';
import FeaturesSplit from '../components/sections/FeaturesSplit';
import ContactUs from '../components/sections/ContactUs';
import TechnologyTiles from '../components/sections/TechnologyTiles';

const Home = () => {

  return (
    <>
      <Hero className="illustration-section-01" />
      <FeaturesTiles />
      <FeaturesSplit invertMobile topDivider imageFill className="illustration-section-02" />
      <TechnologyTiles />
      <ContactUs />
    </>
  );
}

export default Home;